/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".liveClassUnavaibleContainer[_ngcontent-%COMP%]{border-radius:1rem;background-image:linear-gradient(180deg,#f5f5f5,#fff)}@media (min-width:992px){.liveClassUnavaibleContainer[_ngcontent-%COMP%]{padding:6rem 10rem!important}}"];
export { styles as styles };
//# sourceMappingURL=live-class-unavailable.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-unavailable/live-class-unavailable.component.scss.shim.ngstyle.js
// module id = 1398
// module chunks = 26 27 28